// extracted by mini-css-extract-plugin
export default {"daterName":"OthersFriendList_daterName__7mhed","logo":"OthersFriendList_logo__DO7zP"};